/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
} from "@mui/material";
import TextInput from "src/components/input/TextInput";
import { IitemAspiranteResponse } from "src/redux/api/types/aspirantes";
import {
  useActualizarEstadoAspiranteMutation,
  useEditarRegistroHojaDeVidaMutation,
  useLazyObtenerAspirantePorIdQuery,
  useLazyObtenerVerificacionesDeAspiranteQuery,
  useObtenerEstadosDisponiblesDeAspiranteQuery,
} from "src/redux/api/aspirantesApi";
import { ConceptosVerificacionProps } from "src/utils/aspirantes/verificaciones";
import { boxCard } from "src/styles/styles";
import CustomDialog from "src/components/dialogo/CustomDialog";
import EditorDatos from "src/components/editor-datos/EditorDatos";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import {
  EstadoAspirante,
  obtenerOpcionesEstadosAspirante,
} from "src/utils/constantes";
import {
  IverificacionesForm,
  esquemaDeValidacion,
  opcionesVerificacionCampo,
  setValoresInicialesFormEstado,
  setValoresInicialesVerificaciones,
} from "./utils";
import InformacionAspirante from "./InformacionAspirante";

export interface DetalleAspiranteProps {
  aspirante?: IitemAspiranteResponse;
  onSubmit: (valores: IverificacionesForm) => void;
  onClose: () => void;
}

const DetalleAspirante = ({
  aspirante,
  onSubmit,
  onClose,
}: DetalleAspiranteProps) => {
  const [valoresForm, setValoresForm] = useState<any>({});
  const [cargandoVerificaciones, setCargandoVerificaciones] = useState(true);
  const [valoresFormEstado, setValoresFormEstado] = useState<any>({
    estado: "",
    numeroRadicado: "",
    fechaRadicado: "",
    observacionRechazo: "",
  });
  const [mostrarEdicion, setMostrarEdicion] = useState(false);
  const [campoAeditar, setCampoAeditar] = useState<any | undefined>(undefined);
  const [editarDatos] = useEditarRegistroHojaDeVidaMutation();
  const [editarEstado] = useActualizarEstadoAspiranteMutation();

  const estadosParaRadicado = [
    EstadoAspirante.CONSOLIDADO_MATRIZ,
    EstadoAspirante.ENVIADO_MINTIC,
    EstadoAspirante.APROBADO,
    EstadoAspirante.RECHAZADO,
  ];

  const [
    obtenerAspirante,
    { data: aspiranteResp, isLoading: cargandoDetalle },
  ] = useLazyObtenerAspirantePorIdQuery();

  const [
    obtenerVerificacionesAspirante,
    { data: verificiacionesAspiranteResp },
  ] = useLazyObtenerVerificacionesDeAspiranteQuery();

  const { data: estadosDisponiblesResp } =
    useObtenerEstadosDisponiblesDeAspiranteQuery(
      { aspiranteId: aspirante?.aspiranteId ?? "" },
      { skip: !aspirante },
    );

  const onSubmitEstado = (values: any) => {
    editarEstado({
      aspiranteId: aspirante?.aspiranteId ?? "",
      estado: values.estado,
      observacionRechazo: values.observacionRechazo,
    })
      .unwrap()
      .then((resp) => {
        toast.success("Estado actualizado correctamente");
      });

    if (estadosParaRadicado.includes(values.estado)) {
      editarDatos({
        aspiranteId: aspirante?.aspiranteId ?? "",
        informacion: {
          numeroRadicado: values.numeroRadicado,
          fechaRadicado: values.fechaRadicado,
        },
      });
    }
  };

  const construirOpcionesEstados = () => {
    if (!aspiranteResp) return [];
    if (!estadosDisponiblesResp?.estadosDisponibles)
      return obtenerOpcionesEstadosAspirante([aspiranteResp.estado]);
    const estadosBase = estadosDisponiblesResp.estadosDisponibles;
    return obtenerOpcionesEstadosAspirante(
      aspiranteResp.estado
        ? [aspiranteResp.estado, ...estadosBase]
        : estadosBase,
    );
  };

  useEffect(() => {
    if (aspirante) {
      obtenerAspirante(aspirante.aspiranteId)
        .unwrap()
        .then((resp) => {
          setValoresFormEstado(
            setValoresInicialesFormEstado(
              resp.estado,
              resp.numeroRadicado,
              resp.fechaRadicado,
              resp.observacionRechazo,
            ),
          );
        });
      setCargandoVerificaciones(true);
      obtenerVerificacionesAspirante({ aspiranteId: aspirante.aspiranteId })
        .unwrap()
        .then((resp) => {
          setValoresForm(setValoresInicialesVerificaciones(resp));
          setCargandoVerificaciones(false);
        });
    }
  }, [aspirante]);

  if (
    cargandoDetalle ||
    cargandoVerificaciones ||
    !verificiacionesAspiranteResp
  ) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress color="primary" size={40} sx={{ mt: 10 }} />;
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={boxCard}>
        <Formik
          enableReinitialize
          initialValues={valoresFormEstado}
          validationSchema={esquemaDeValidacion}
          onSubmit={onSubmitEstado}
        >
          {({ values, setFieldValue, handleChange }) => {
            return (
              <Form
                autoComplete="off"
                id="form-estado"
                style={{ width: "100%" }}
              >
                <Box>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={9}
                      md={estadosParaRadicado.includes(values.estado) ? 3 : 9}
                    >
                      <TextInput
                        label="Estado de la solicitud"
                        name="estado"
                        type="select"
                        opciones={construirOpcionesEstados()}
                        data-testid="estado-solicitud"
                      />
                    </Grid>
                    {estadosParaRadicado.includes(values.estado) && (
                      <>
                        <Grid item xs={3} md={3}>
                          <TextInput
                            label="Número de radicado"
                            name="numeroRadicado"
                            type="text"
                            data-testid="estado-solicitud"
                          />
                        </Grid>
                        <Grid item xs={3} md={3}>
                          <TextInput
                            label="Fecha de radicado"
                            name="fechaRadicado"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            data-testid="estado-solicitud"
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item xs={3} md={3}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100%"
                      >
                        <LoadingButton
                          variant="contained"
                          color="primary"
                          sx={{ color: "white" }}
                          type="submit"
                          data-testid="btn-nuevo-maestro"
                          form="form-estado"
                        >
                          Guardar
                        </LoadingButton>
                      </Box>
                    </Grid>
                  </Grid>
                  {
                    EstadoAspirante.RECHAZADO === values.estado &&
                  <Grid container spacing={2}>
                    <Grid item md={9}>
                      <TextInput
                        label="Observaciones"
                        name="observacionRechazo"
                        type="text"
                      />
                    </Grid>
                  </Grid>
                  }
                </Box>
              </Form>
            );
          }}
        </Formik>
      </Box>
      <Formik
        enableReinitialize
        initialValues={valoresForm}
        validationSchema={esquemaDeValidacion}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, handleChange }) => {
          return (
            <Form
              autoComplete="off"
              id="form-verificacion"
              style={{ width: "100%" }}
            >
              {aspiranteResp &&
                Object.entries(ConceptosVerificacionProps).map(
                  ([key, value]) => {
                    return (
                      <Box
                        px={2}
                        my={0.5}
                        sx={boxCard}
                        display="flex"
                        width="100%"
                        alignItems="center"
                        key={value.campo}
                      >
                        <Box width="100%" display="flex" alignItems="center">
                          <InformacionAspirante
                            props={value as any}
                            aspirante={aspiranteResp}
                          />
                          <IconButton
                            aria-label="edit"
                            onClick={() => {
                              setMostrarEdicion(true);
                              setCampoAeditar({
                                clave: key,
                                valor: (aspiranteResp as any)[value.campo],
                                campo: value.campo,
                              });
                            }}
                            sx={{
                              height: 40, // Altura fija
                              width: 40, // Hace el botón cuadrado
                              minWidth: 40, // Asegura que el ancho no cambie
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Icon>edit </Icon>
                          </IconButton>
                        </Box>
                        <Box width="100%">
                          <Grid container spacing={2}>
                            <Grid item xs={6} md={6}>
                              <TextInput
                                label=""
                                name={`${value.campo}.estado`}
                                type="select"
                                opciones={opcionesVerificacionCampo}
                                data-testid="tipo-cc"
                              />
                            </Grid>
                            <Grid item xs={6} md={6}>
                              <TextInput
                                label="Observaciones"
                                name={`${value.campo}.comentarios`}
                                type="text"
                                data-testid="usuario-id"
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    );
                  },
                )}
            </Form>
          );
        }}
      </Formik>
      <CustomDialog
        mostrar={mostrarEdicion}
        onClose={() => {
          setCampoAeditar(undefined);
          setMostrarEdicion(false);
        }}
        contenido={
          <EditorDatos
            campos={[campoAeditar as any]}
            aspiranteId={aspirante?.aspiranteId ?? ""}
            submit={(values: any) => {
              editarDatos({
                aspiranteId: aspirante?.aspiranteId ?? "",
                informacion: values,
              });
              setMostrarEdicion(false);
              setCampoAeditar(undefined);
            }}
          />
        }
        acciones={
          <>
            <Button
              onClick={() => {
                setMostrarEdicion(false);
                setCampoAeditar(undefined);
              }}
            >
              Cancelar
            </Button>
            <LoadingButton
              variant="contained"
              color="primary"
              sx={{ color: "white" }}
              type="submit"
              data-testid="btn-nuevo-maestro"
              form="form-editor"
            >
              Guardar
            </LoadingButton>
          </>
        }
        titulo="Editar información"
        tamanioMaximo="md"
        fullWidth
      />
    </Box>
  );
};

export default DetalleAspirante;
